"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateWeekend = void 0;
const isDateWeekend = (date) => {
    const dayOfWeek = date.getDay();
    // 6 = Saturday and 0 = Sunday
    return dayOfWeek === 6 || dayOfWeek === 0;
};
exports.isDateWeekend = isDateWeekend;
//# sourceMappingURL=date.utils.js.map